import { FC } from "react";

import { CROSS_REMOVE_ICON_PATHS } from "mds/utils/icon-paths";
import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CrossRemoveIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {CROSS_REMOVE_ICON_PATHS.map((d) => (
      <path
        d={d}
        key={d}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
    ))}
  </svg>
);
